import api from '../api/axios.config';

export const dashboardService = {
  getOverview: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/sales-overview`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getCategoryA: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/inventory-health-overview/category_a`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getCategoryB: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/inventory-health-overview/category_b`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getCategoryC: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/inventory-health-overview/category_c`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getOverstock: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/inventory-health-overview/overstock`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getUnderstock: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/inventory-health-overview/understock`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getStockout: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/inventory-health-overview/out-of-stock`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getStockCoverage: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/stock-coverage`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },

  getSkuSalesOverview: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/sku-sales-overview`, { params });
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  getBranchSalesOverview: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/branch-sales-overview`, { params });
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  plotData: async (view_type, date_from, date_to) => {
    try {
      const params = {};

      if (view_type) params.view_type = view_type;
      if (date_from) params.date_from = date_from;
      if (date_to) params.date_to = date_to;

      const response = await api.get(`/dashboard/plot-data`, { params });
      return response.data;
    } 
    catch (error) {
      throw error;
    }
  },
};
